module.exports = __webpack_public_path__ + "static/media/tram.362aec66.svg";